import { PlanOption } from "./planoption";

export class TaskOption {
    public id: number;
    public option: PlanOption;
    public isAdd: boolean;
}